import React, {useEffect} from "react";
import {SearchContactsInner} from "../../../../../components/common/modal/inner/SearchContactsInner";
import {useModal} from "../../../../../hooks";
import SearchAddressInner from "../../../../../components/common/modal/inner/SearchAddressInner";
import {PcsDetailType} from "../../detail/interface";
import {useReadShippingSelectBox} from "../../../../order/orders/create/hooks/useReadShippingSelectBox";
import {useReadPaymentSelectBox} from "../../../../order/orders/create/hooks/useReadPaymentSelectBox";
import {UseFormRegister, UseFormSetValue} from "react-hook-form";
import {useUser} from "../../../../../util/userContext/UserContext";
import {SearchBusinessPartnerInner} from "../../../../../components/common/modal/inner/SearchBusinessPartnerInner";
import {useLocation} from "react-router-dom";
import useSetPurchaseValue from "../../detail/hooks/useSetPurchaseValue";

interface PropsType {
    watchCreateDetail: PcsDetailType
    register: UseFormRegister<PcsDetailType>
    setValue: UseFormSetValue<PcsDetailType>
    menuTitleText: string
    isOrderRequest?: boolean
}

export default function Tab1({watchCreateDetail, register, setValue, menuTitleText, isOrderRequest}: PropsType) {
    const {pathname} = useLocation()
    const {user} = useUser()
    const {handleModal} = useModal();

    const {data: shipmentList} = useReadShippingSelectBox()
    const {data: paymentList} = useReadPaymentSelectBox()

    const {setContact, setAccount} = useSetPurchaseValue()

    // NOTE: 수신자(_new_l_recipient_value), 계산서담당자(newLInvoiceAgentValue), 수주고객(newLContactValue) 선택 모달
    const btnSearchRecipient = (key: "newLRecipientValue" | "newLInvoiceAgentValue" | "newLContactValue") => {
        handleModal({
            isOpen: true,
            contents: (
                <SearchContactsInner
                    confirmCallback={(item) => {
                        setValue(key, item.contactId)

                        if (key === "newLRecipientValue") {
                            setValue("recipientName", item.fullName)
                            setValue("recipientMobile", item.mobilePhone)
                        } else if (key === "newLInvoiceAgentValue") {
                            setValue("taxCharge", item.fullName)
                            setValue("taxMobile", item.mobilePhone)
                            setValue("taxEmail", item.emailAddress1)
                        } else if (key === "newLContactValue") {
                            setContact(item, setValue)
                        }
                    }}
                    modalDepth={1}
                    args={user && !isOrderRequest ? {userId: user.userId} : null}
                />
            ),
            type: "",
            title: "연락처 조회",
            modalSize: "xxl",
        })
    }

    // NOTE: 발송지 선택 모달
    const btnSearchAddress = () => {
        handleModal({
            isOpen: true,
            contents: (
                <SearchAddressInner
                    confirmCallback={(item) => {
                        if (setValue) {
                            setValue("newLAddressValue", item?.new_addressid);
                            setValue("addressName", item?.newName);
                            setValue("address1", item?.new_txt_line1);
                            setValue("address2", item?.new_txt_line2);
                        }
                    }}
                    modalDepth={1}
                    args={user && !isOrderRequest ? {userId: user.userId} : null}
                />
            ),
            type: "",
            title: "주소 조회",
            modalSize: "xxl",
        })
    }

    // NOTE: 고객사 선택 모달
    const btnSearchAccount = () => {
        handleModal({
            isOpen: true,
            contents: (
                <SearchBusinessPartnerInner
                    confirmCallback={(item) => {
                        setAccount(item, setValue)
                    }}
                    modalDepth={1}
                />
            ),
            type: "",
            title: "고객사 조회",
            modalSize: "xxl",
        })
    }

    useEffect(() => {
        if (!isOrderRequest && paymentList) {
            const value = paymentList.find((el: any) => el.name.includes("현금"))?.id

            setValue("newPPayment", value)
        }
    }, [paymentList]);

    return <div className="content_wrap">
        <h5 className="subheading mt-0">{menuTitleText}정보</h5>
        <div className="table_scroll mb-0">
            <table className="table table-bordered my_table table_detail">
                <tbody>
                <tr>
                    <th>고객사 <span className="required">*</span></th>
                    <td className="p-4px">
                        <div className="d-flex">
                            <input type="text" className="form-control"
                                   value={watchCreateDetail.enduserName}
                                   disabled/>
                            <button
                                className="btn btn-info btn_search w-100px ms-5px"
                                onClick={btnSearchAccount}
                                disabled={pathname.includes("purchase/pcs")}
                            >
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                                    alt=""
                                />찾기
                            </button>
                        </div>
                    </td>
                    <th>수주고객 <span className="required">*</span></th>
                    <td className="p-4px">
                        <div className="d-flex">
                            <input type="text" className="form-control"
                                   value={watchCreateDetail.contactName}
                                   disabled/>
                            <button
                                className="btn btn-info btn_search w-100px ms-5px"
                                onClick={() => btnSearchRecipient("newLContactValue")}
                                disabled={pathname.includes("purchase/pcs")}
                            >
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                                    alt=""
                                />찾기
                            </button>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th style={{width: "16.66%"}}>발송요청일 <span className="required">*</span></th>
                    <td style={{width: "33.34%"}} className="p-4px">
                        <input type="date"
                               className="form-control"
                               max="9999-12-31"
                               value={watchCreateDetail.newDtRequestShipment}
                               {...register("newDtRequestShipment")}/>
                    </td>
                    <th style={{width: "16.66%"}}>발송방법 <span className="required">*</span></th>
                    <td className="p-4px">
                        <select className="form-select"
                                value={watchCreateDetail.newPShipment}
                                {...register("newPShipment")}>
                            <option value={0}>선택</option>
                            {shipmentList?.map((el: any) => <option value={el.id}>{el.name}</option>)}
                        </select>
                    </td>
                </tr>
                <tr>
                    <th>수신자 <span className="required">*</span></th>
                    <td className="p-4px">
                        <div className="d-flex">
                            <input type="text" className="form-control"
                                   value={watchCreateDetail.recipientName}
                                   disabled/>
                            <button
                                className="btn btn-info btn_search w-100px ms-5px"
                                onClick={() => btnSearchRecipient("newLRecipientValue")}>
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                                    alt=""
                                />찾기
                            </button>
                        </div>
                    </td>
                    <th>연락처</th>
                    <td className="p-4px">
                        <input type="text" className="form-control"
                               value={watchCreateDetail.recipientMobile}
                               disabled/>
                    </td>
                </tr>
                <tr>
                    {/*<th>발송지 <span className="required">*</span></th>*/}
                    <th>발송지</th>
                    <td className="p-4px" colSpan={3}>
                        <div className="d-flex">
                            <input type="text" className="form-control"
                                   value={watchCreateDetail.addressName}
                                   disabled/>
                            <button
                                className="btn btn-info btn_search w-100px ms-5px"
                                onClick={btnSearchAddress}>
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                                    alt=""
                                />찾기
                            </button>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>주소1</th>
                    <td className="p-4px">
                        <input type="text" className="form-control"
                               value={watchCreateDetail.address1}
                               disabled/>
                    </td>
                    <th>주소2</th>
                    <td className="p-4px">
                        <input type="text" className="form-control"
                               value={watchCreateDetail.address2}
                               disabled/>
                    </td>
                </tr>
                <tr>
                    <th>신규 주소</th>
                    <td className="p-4px" colSpan={3}>
                        <div className="d-flex">
                            <input type="text"
                                   className="form-control w-150px h-34px"
                                   value={watchCreateDetail.customPostcode}
                                   disabled/>
                            <input type="text"
                                   className="form-control ms-5px h-34px"
                                   value={watchCreateDetail.customAddress1}
                                   disabled/>
                        </div>
                        <div className="d-flex mt-6px">
                            <input type="text"
                                   className="form-control h-34px"
                                   value={watchCreateDetail.customAddress2}
                                   disabled/>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>고객 메모</th>
                    <td className="p-4px" colSpan={3}>
                        <input type="text" className="form-control"
                               value={watchCreateDetail.customerMemo}
                               {...register("customerMemo")}/>
                    </td>
                </tr>
                {/*<tr>
                    <th>{menuTitleText}메모</th>
                    <td className="p-4px" colSpan={3}>
                        <input type="text" className="form-control"
                               value={watchCreateDetail.memo}
                               {...register("memo")}/>
                    </td>
                </tr>*/}
                </tbody>
            </table>
        </div>

        <h5 className="subheading mt-20px">수금정보</h5>
        <div className="table_scroll mb-0">
            <table className="table table-bordered my_table table_detail">
                {/*<tbody>*/}
                {/*<tr>*/}
                {/*    <th style={{width: "16.66%"}}>수금예정일 {!pathname.includes("purchase/pcs") &&*/}
                {/*        <span className="required">*</span>}</th>*/}
                {/*    <td className="p-4px" style={{width: "33.34%"}}>*/}
                {/*        <input type="date"*/}
                {/*               className="form-control"*/}
                {/*               max="9999-12-31"*/}
                {/*               value={watchCreateDetail.newDtEstimatedCollection}*/}
                {/*               disabled={pathname.includes("purchase/pcs")}*/}
                {/*               {...register("newDtEstimatedCollection")}/>*/}
                {/*    </td>*/}
                {/*    <th style={{width: "16.66%"}}>결제방법 <span className="required">*</span></th>*/}
                {/*    <td className="p-4px">*/}
                {/*        <select className="form-select"*/}
                {/*                value={watchCreateDetail.newPPayment}*/}
                {/*                {...register("newPPayment")}*/}
                {/*                disabled={!isOrderRequest}>*/}
                {/*            <option value={0}>선택</option>*/}
                {/*            {paymentList?.map((el: any) => <option value={el.id}>{el.name}</option>)}*/}
                {/*        </select>*/}
                {/*    </td>*/}
                {/*</tr>*/}
                {/*<tr>*/}
                {/*    <th>계산서담당자 <span className="required">*</span></th>*/}
                {/*    <td className="p-4px">*/}
                {/*        <div className="d-flex">*/}
                {/*            <input type="text" className="form-control"*/}
                {/*                   value={watchCreateDetail.taxCharge}*/}
                {/*                   disabled/>*/}
                {/*            <button*/}
                {/*                className="btn btn-info btn_search w-100px ms-5px"*/}
                {/*                onClick={() => btnSearchRecipient("newLInvoiceAgentValue")}>*/}
                {/*                <img*/}
                {/*                    src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}*/}
                {/*                    alt=""*/}
                {/*                />찾기*/}
                {/*            </button>*/}
                {/*        </div>*/}
                {/*    </td>*/}
                {/*    <th>연락처</th>*/}
                {/*    <td className="p-4px">*/}
                {/*        <input type="text" className="form-control"*/}
                {/*               value={watchCreateDetail.taxMobile}*/}
                {/*               disabled/>*/}
                {/*    </td>*/}
                {/*</tr>*/}
                {/*<tr>*/}
                {/*    <th>이메일</th>*/}
                {/*    <td className="p-4px" colSpan={3}>*/}
                {/*        <input type="text" className="form-control"*/}
                {/*               value={watchCreateDetail.taxEmail}*/}
                {/*               disabled/>*/}
                {/*    </td>*/}
                {/*</tr>*/}
                {/*</tbody>*/}
                <tbody>
                <tr>
                    <th style={{width: "16.66%"}}>수금예정일 {!pathname.includes("purchase/pcs") &&
                        <span className="required">*</span>}</th>
                    <td className="p-4px" style={{width: "33.34%"}}>
                        <input type="date"
                               className="form-control"
                               max="9999-12-31"
                               value={watchCreateDetail.newDtEstimatedCollection}
                               disabled={pathname.includes("purchase/pcs")}
                               {...register("newDtEstimatedCollection")}/>
                    </td>
                    <th style={{width: "16.66%"}}>계산서담당자 <span className="required">*</span></th>
                    <td className="p-4px">
                        <div className="d-flex">
                            <input type="text" className="form-control"
                                   value={watchCreateDetail.taxCharge}
                                   disabled/>
                            <button
                                className="btn btn-info btn_search w-100px ms-5px"
                                onClick={() => btnSearchRecipient("newLInvoiceAgentValue")}>
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                                    alt=""
                                />찾기
                            </button>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>연락처</th>
                    <td className="p-4px">
                        <input type="text" className="form-control"
                               value={watchCreateDetail.taxMobile}
                               disabled/>
                    </td>
                    <th>이메일</th>
                    <td className="p-4px">
                        <input type="text" className="form-control"
                               value={watchCreateDetail.taxEmail}
                               disabled/>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
}